<template>
    <div>
        <v-toolbar elevation="3" color="#0672cb" density="compact">
            <v-toolbar-title>Google Analytics Dashboard
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn icon>
                <v-icon @click="systemStore.routerTo('home-partner')">mdi-close-circle-outline</v-icon>
            </v-btn>
        </v-toolbar>
        <v-row justify="center" style="background-color: #0672cb;">

            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="body-text text-white mt-4">
                            <p class="">
                                <LanguagePlaceholder is-html
                                    default-text="This report contains a collection of metrics and dimensions as per google analytics for the last 7 days unless stated otherwise." />
                            </p>
                            <br />
                            <p>

                            </p>
                        </div>
                    </v-container>

                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>

        <v-container fluid>
            <div class="d-flex justify-space-around align-center mb-6 ">
                <v-card class="ma-2 text-center" width="100%" @click="clickBlock_activeUsers">
                    <v-sheet color="#0d2154" class="pa-4 py-2" height="100">
                        <div class=" text-h6 text-truncate text-uppercase">Active Users</div>
                        <h1>{{ block_activeUsers }}</h1>
                    </v-sheet>
                </v-card>
                <v-card class="ma-2 text-center" width="100%" @click="clickBlock_views">
                    <v-sheet color="#0d2154" class="pa-4 py-2 " height="100">
                        <div class=" text-h6 text-truncate text-uppercase">Views</div>
                        <h1>{{ block_views }}</h1>
                    </v-sheet>
                </v-card>
                <v-card class="ma-2 text-center" width="100%" @click="clickBlock_sessions">
                    <v-sheet color="#0d2154" class="pa-4 py-2 " height="100">
                        <div class=" text-h6 text-truncate text-uppercase">Sessions</div>
                        <h1>{{ block_sessions }}</h1>
                    </v-sheet>
                </v-card>
                <v-card class="ma-2 text-center" width="100%" @click="clickBlock_eventCount">
                    <v-sheet color="#0d2154" class="pa-4 py-2 " height="100">
                        <div class=" text-h6 text-truncate text-uppercase">Event Count</div>
                        <h1>{{ block_eventCount }}</h1>
                    </v-sheet>
                </v-card>
            </div>
            <v-row>
                <v-col cols="6">
                    <v-window v-model="selectedTab">
                        <v-window-item :value="0">
                            <apexchart height="300" ref="chart_ActiveUsersPerDay" type="line"
                                :options="activeUsersPerDayOptions" :series="activeUsersPerDayOptions.series">
                            </apexchart>
                        </v-window-item>
                        <v-window-item :value="1">
                            <apexchart height="300" ref="chart_ViewsPerDay" type="line" :options="viewsPerDayOptions"
                                :series="viewsPerDayOptions.series"></apexchart>
                        </v-window-item>
                        <v-window-item :value="2">
                            <apexchart height="300" ref="chart_SessionsPerDay" type="line"
                                :options="sessionsPerDayOptions" :series="sessionsPerDayOptions.series"></apexchart>
                        </v-window-item>
                        <v-window-item :value="3">
                            <apexchart height="300" ref="chart_EventCountPerDay" type="line"
                                :options="eventCountPerDayOptions" :series="eventCountPerDayOptions.series"></apexchart>
                        </v-window-item>
                    </v-window>
                </v-col>
                <v-col cols="6">
                    <apexchart height="300" ref="chart_ActiveUsersPerMinute" type="bar"
                        :options="activeUsersPerMinuteOptions" :series="activeUsersPerMinuteOptions.series"></apexchart>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <apexchart height="300" ref="chart_ActiveUsersByCountry" type="bar"
                        :options="activeUsersByCountryOptions" :series="activeUsersByCountryOptions.series"></apexchart>
                </v-col>
                <v-col cols="6">
                    <apexchart height="300" ref="chart_ViewsByPageTitle" type="bar" :options="viewsByPageTitleOptions"
                        :series="viewsByPageTitleOptions.series"></apexchart>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>


<script setup>
import { ref, onMounted, computed, toRaw } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useGoogleAnalyticsStore } from '@/stores/google-analytics'

const googleAnalyticsStore = useGoogleAnalyticsStore()
const systemStore = useSystemStore()

const selectedTab = ref(0)

const chart_ActiveUsersByCountry = ref(null)
const chart_ActiveUsersPerMinute = ref(null)
const chart_ViewsByPageTitle = ref(null)
const chart_ActiveUsersPerDay = ref(null)
const chart_SessionsPerDay = ref(null)
const chart_ViewsPerDay = ref(null)
const chart_EventCountPerDay = ref(null)

const analyticsData = ref({})
const RTAnalyticsData = ref({})
const activeUsersPerDayData = ref({})
const sessionsPerDayData = ref({})
const viewsPerDayData = ref({})
const eventCountPerDayData = ref({})



const activeUsersByCountryOptions = ref({
    chart: {
        id: 'vuechart-example',
        height: 150,
        // background: '#1E1E1E',  // Dark background color
        animations: {
            enabled: true, // Enable animations
            easing: 'easeinout', // Easing function ('linear', 'easein', 'easeout', 'easeinout')
            speed: 1500, // Animation duration in milliseconds
            animateGradually: {
                enabled: true,
                delay: 200
            },
            dynamicAnimation: {
                enabled: true,
                speed: 1000
            }
        }
    },
    // theme: {
    //     mode: 'dark'  // Set dark theme
    // },
    series: [{
        name: 'Active Users',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]  // Example data
    }],
    xaxis: {
        categories: [],
        labels: {
            style: {
                colors: '#FFFFFF'  // White x-axis labels
            }
        }
    },
    // colors: getChartColors(10),  // Generate random colors for bars
    plotOptions: {
        bar: {
            horizontal: true,  // Vertical bars
            distributed: true  // Keep bars uniform in color
        }
    },
    title: {
        text: 'Active users by Location (Last 7 days)',
        align: 'center',
        style: {
            fontSize: '16px',                   // Font size
            fontWeight: 'bold',                 // Font weight
            fontFamily: 'Arial, sans-serif',    // Font family
            color: '#0d2154',                   // Title color
        },
    },
    legend: {
        show: false  // Hides the legend
    }
})

const activeUsersPerMinuteOptions = ref({
    chart: {
        id: 'vuechart-activeUsersPerMinute',
        height: 150,
        // background: '#1E1E1E',  // Dark background color
        animations: {
            enabled: true, // Enable animations
            easing: 'easeinout', // Easing function ('linear', 'easein', 'easeout', 'easeinout')
            speed: 1500, // Animation duration in milliseconds
            animateGradually: {
                enabled: true,
                delay: 200
            },
            dynamicAnimation: {
                enabled: true,
                speed: 1000
            }
        }
    },
    // theme: {
    //     mode: 'dark'  // Set dark theme
    // },
    series: [{
        name: 'Active Users',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]  // Example data
    }],
    xaxis: {
        categories: [],
        // labels: {
        //     style: {
        //         colors: '#FFFFFF'  // White x-axis labels
        //     }
        // }
    },
    // colors: getChartColors(10),  // Generate random colors for bars
    plotOptions: {
        bar: {
            horizontal: false,  // Vertical bars
            distributed: false  // Keep bars uniform in color
        }
    },
    title: {
        text: 'Active Users Per Minute (Last 30 Minutes)',
        align: 'center',
        style: {
            fontSize: '16px',                   // Font size
            fontWeight: 'bold',                 // Font weight
            fontFamily: 'Arial, sans-serif',    // Font family
            color: '#0d2154',                   // Title color
        },
    },
    legend: {
        show: false  // Hides the legend
    }
})

const viewsByPageTitleOptions = ref({
    chart: {
        id: 'vuechart-example',
        height: 350,
        // background: '#1E1E1E',  // Dark background color
        animations: {
            enabled: true, // Enable animations
            easing: 'easeinout', // Easing function ('linear', 'easein', 'easeout', 'easeinout')
            speed: 1500, // Animation duration in milliseconds
            animateGradually: {
                enabled: true,
                delay: 200
            },
            dynamicAnimation: {
                enabled: true,
                speed: 1000
            }
        }
    },
    // theme: {
    //     mode: 'dark'  // Set dark theme
    // },
    series: [{
        name: 'Page Title',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]  // Example data
    }],
    xaxis: {
        categories: [],
        labels: {
            style: {
                colors: '#FFFFFF'  // White x-axis labels
            }
        }
    },
    // colors: getChartColors(10),  // Generate random colors for bars
    plotOptions: {
        bar: {
            horizontal: true,  // Vertical bars
            distributed: false  // Keep bars uniform in color
        }
    },
    title: {
        text: 'Views By Page Title (Last 7 days)',
        align: 'center',
        style: {
            fontSize: '16px',                   // Font size
            fontWeight: 'bold',                 // Font weight
            fontFamily: 'Arial, sans-serif',    // Font family
            color: '#0d2154',                   // Title color
        },
    },
    legend: {
        show: false  // Hides the legend
    }
})

const activeUsersPerDayOptions = ref({
    chart: {
        id: 'vuechart-activeUsersPerDay',
        animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 1500,
            animateGradually: {
                enabled: true,
                delay: 200
            },
            dynamicAnimation: {
                enabled: true,
                speed: 1000
            }
        }
    },
    series: [{
        name: 'Active Users',
        type: 'line',
        data: [0, 0, 0, 0, 0, 0, 0]
    }],
    stroke: {
        curve: 'straight'
    },
    dataLabels: {
        enabled: true, // Enable data points
        offsetX: -10, // Horizontal offset of data label
        offsetY: -10, // Vertical offset of data label
        style: {
            fontSize: '16px',
            colors: ['#FFA41B'], // Set the color for data labels
            padding: 10
        },
        background: {
            enabled: true,
            foreColor: '#fff',
            padding: 10,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.8,
            dropShadow: {
                enabled: true,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.45
            }
        },
    },
    markers: {
        size: 10,
        strokeColors: '#fff',
        strokeWidth: 2,
        hover: {
            size: 7,
        },
    },
    xaxis: {
        categories: [],
    },
    title: {
        text: 'Active Users Per Day (Last 7 days)',
        align: 'center',
        style: {
            fontSize: '16px',                   // Font size
            fontWeight: 'bold',                 // Font weight
            fontFamily: 'Arial, sans-serif',    // Font family
            color: '#0d2154',                   // Title color
        },
    },
    legend: {
        show: false  // Hides the legend
    }
})
const sessionsPerDayOptions = ref({
    chart: {
        id: 'vuechart-sessionsPerDay',
        animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 1500,
            animateGradually: {
                enabled: true,
                delay: 200
            },
            dynamicAnimation: {
                enabled: true,
                speed: 1000
            }
        }
    },
    series: [{
        name: 'Sessions',
        type: 'line',
        data: [0, 0, 0, 0, 0, 0, 0]
    }],
    stroke: {
        curve: 'straight'
    },
    dataLabels: {
        enabled: true, // Enable data points
        offsetX: -10, // Horizontal offset of data label
        offsetY: -10, // Vertical offset of data label
        style: {
            fontSize: '16px',
            colors: ['#FFA41B'], // Set the color for data labels
            padding: 10
        },
        background: {
            enabled: true,
            foreColor: '#fff',
            padding: 10,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.8,
            dropShadow: {
                enabled: true,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.45
            }
        },
    },
    markers: {
        size: 10,
        strokeColors: '#fff',
        strokeWidth: 2,
        hover: {
            size: 7,
        },
    },
    xaxis: {
        categories: [],
    },
    title: {
        text: 'Sessions Per Day (Last 7 days)',
        align: 'center',
        style: {
            fontSize: '16px',                   // Font size
            fontWeight: 'bold',                 // Font weight
            fontFamily: 'Arial, sans-serif',    // Font family
            color: '#0d2154',                   // Title color
        },
    },
    legend: {
        show: false  // Hides the legend
    }
})
const viewsPerDayOptions = ref({
    chart: {
        id: 'vuechart-viewsPerDay',
        animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 1500,
            animateGradually: {
                enabled: true,
                delay: 200
            },
            dynamicAnimation: {
                enabled: true,
                speed: 1000
            }
        }
    },
    series: [{
        name: 'Views',
        type: 'line',
        data: [0, 0, 0, 0, 0, 0, 0]
    }],
    stroke: {
        curve: 'straight'
    },
    dataLabels: {
        enabled: true, // Enable data points
        offsetX: -10, // Horizontal offset of data label
        offsetY: -10, // Vertical offset of data label
        style: {
            fontSize: '16px',
            colors: ['#FFA41B'], // Set the color for data labels
            padding: 10
        },
        background: {
            enabled: true,
            foreColor: '#fff',
            padding: 10,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.8,
            dropShadow: {
                enabled: true,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.45
            }
        },
    },
    markers: {
        size: 10,
        strokeColors: '#fff',
        strokeWidth: 2,
        hover: {
            size: 7,
        },
    },
    xaxis: {
        categories: [],
    },
    title: {
        text: 'Views Per Day (Last 7 days)',
        align: 'center',
        style: {
            fontSize: '16px',                   // Font size
            fontWeight: 'bold',                 // Font weight
            fontFamily: 'Arial, sans-serif',    // Font family
            color: '#0d2154',                   // Title color
        },
    },
    legend: {
        show: false  // Hides the legend
    }
})
const eventCountPerDayOptions = ref({
    chart: {
        id: 'vuechart-eventCountPerDay',
        animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 1500,
            animateGradually: {
                enabled: true,
                delay: 200
            },
            dynamicAnimation: {
                enabled: true,
                speed: 1000
            }
        }
    },
    series: [{
        name: 'Event Count',
        type: 'line',
        data: [0, 0, 0, 0, 0, 0, 0]
    }],
    stroke: {
        curve: 'straight'
    },
    dataLabels: {
        enabled: true, // Enable data points
        offsetX: -10, // Horizontal offset of data label
        offsetY: -10, // Vertical offset of data label
        style: {
            fontSize: '16px',
            colors: ['#FFA41B'], // Set the color for data labels
            padding: 10
        },
        background: {
            enabled: true,
            foreColor: '#fff',
            padding: 10,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.8,
            dropShadow: {
                enabled: true,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.45
            }
        },
    },
    markers: {
        size: 10,
        strokeColors: '#fff',
        strokeWidth: 2,
        hover: {
            size: 7,
        },
    },
    xaxis: {
        categories: [],
    },
    title: {
        text: 'Event Count Per Day (Last 7 days)',
        align: 'center',
        style: {
            fontSize: '16px',                   // Font size
            fontWeight: 'bold',                 // Font weight
            fontFamily: 'Arial, sans-serif',    // Font family
            color: '#0d2154',                   // Title color
        },
    },
    legend: {
        show: false  // Hides the legend
    }
})


const block_activeUsers = ref(0)
const block_views = ref(0)
const block_sessions = ref(0)
const block_eventCount = ref(0)

const animateCountUp = (reference, targetValue, duration) => {
    const increment = targetValue / (duration / 16);  // Approx. 60 FPS (16ms per frame)
    let currentValue = 0;

    const interval = setInterval(() => {
        currentValue += increment;
        if (currentValue >= targetValue) {
            reference.value = targetValue;  // Ensure exact final value
            clearInterval(interval);
        } else {
            reference.value = Math.floor(currentValue);
        }
    }, 16);  // Run every 16ms for smooth animation
};

const colorTemplates = [
    '#FF5733', '#33FF57', '#3357FF', '#FF33A6', '#A633FF',
    '#33FFF6', '#F6FF33', '#FF8C33', '#8C33FF', '#33FF8C'
];

const getChartColors = (numColors) => {
    return Array.from({ length: numColors }, (_, index) => colorTemplates[index % colorTemplates.length]);
};


const clickBlock_activeUsers = () => {
    selectedTab.value = 0

    getActiveUsersPerDayData()
}

const clickBlock_views = () => {
    selectedTab.value = 1

    getViewsPerDayData()
}

const clickBlock_sessions = () => {
    selectedTab.value = 2

    getSessionsPerDayData()
}

const clickBlock_eventCount = () => {
    selectedTab.value = 3

    getEventCountPerDayData()
}




onMounted(() => {
    getAnalyticsData()
    getRTAnalyticsData()
    getActiveUsersPerDayData()
})

const getAnalyticsData = () => {
    googleAnalyticsStore.getAnalyticsData().then(result => {
        analyticsData.value = result

        // populate the data blocks
        animateCountUp(block_activeUsers, analyticsData.value.activeUsers, 1500)
        animateCountUp(block_views, analyticsData.value.views, 1500)
        animateCountUp(block_sessions, analyticsData.value.sessions, 1500)
        animateCountUp(block_eventCount, analyticsData.value.eventCount, 1500)

        // update chart data: activeUsersByCountry
        chart_ActiveUsersByCountry.value.updateOptions({
            xaxis: {
                categories: analyticsData.value.activeUsersByCountry_Last7Days.map(o => o.key)
            }
        })

        chart_ActiveUsersByCountry.value.updateSeries([
            {
                name: 'Countries',
                data: analyticsData.value.activeUsersByCountry_Last7Days.map(o => o.value), // New data
            },
        ]);


        // update chart data: viewsByPageTitle
        chart_ViewsByPageTitle.value.updateOptions({
            xaxis: {
                categories: analyticsData.value.viewsByPageTitle_Last7Days.map(o => o.key)
            }
        })

        chart_ViewsByPageTitle.value.updateSeries([
            {
                name: 'PageTitle',
                data: analyticsData.value.viewsByPageTitle_Last7Days.map(o => o.value), // New data
            },
        ]);

    }).catch(error => {
        var t = error
    })
}

const getRTAnalyticsData = () => {
    googleAnalyticsStore.getRTAnalyticsData().then(result => {
        RTAnalyticsData.value = result

        chart_ActiveUsersPerMinute.value.updateOptions({
            xaxis: {
                categories: RTAnalyticsData.value.activeUsersPerMinute_Last30Minutes.map(o => o.key)
            }
        })

        chart_ActiveUsersPerMinute.value.updateSeries([
            {
                name: 'Active Users',
                data: RTAnalyticsData.value.activeUsersPerMinute_Last30Minutes.map(o => o.value), // New data
            },
        ]);



    }).catch(error => {

    })
}

const getActiveUsersPerDayData = () => {

    googleAnalyticsStore.getActiveUsersPerDayData().then(result => {
        activeUsersPerDayData.value = result

        chart_ActiveUsersPerDay.value.updateOptions({
            xaxis: {
                categories: activeUsersPerDayData.value.map(o => o.key)
            }
        })



        chart_ActiveUsersPerDay.value.updateSeries([
            {
                name: 'Active Users',
                data: activeUsersPerDayData.value.map(o => o.value),
            },
        ]);
    })
}

const getSessionsPerDayData = () => {
    googleAnalyticsStore.getSessionsPerDayData().then(result => {
        sessionsPerDayData.value = result

        chart_SessionsPerDay.value.updateOptions({
            xaxis: {
                categories: sessionsPerDayData.value.map(o => o.key)
            }
        })

        chart_SessionsPerDay.value.updateSeries([
            {
                name: 'Sessions',
                data: sessionsPerDayData.value.map(o => o.value),
            },
        ]);
    })
}

const getViewsPerDayData = () => {
    googleAnalyticsStore.getViewsPerDayData().then(result => {
        viewsPerDayData.value = result

        chart_ViewsPerDay.value.updateOptions({
            xaxis: {
                categories: viewsPerDayData.value.map(o => o.key)
            }
        })

        chart_ViewsPerDay.value.updateSeries([
            {
                name: 'Views',
                data: viewsPerDayData.value.map(o => o.value),
            },
        ]);
    })
}

const getEventCountPerDayData = () => {
    googleAnalyticsStore.getEventCountPerDayData().then(result => {
        eventCountPerDayData.value = result

        chart_EventCountPerDay.value.updateOptions({
            xaxis: {
                categories: eventCountPerDayData.value.map(o => o.key)
            }
        })

        chart_EventCountPerDay.value.updateSeries([
            {
                name: 'Event Count',
                data: eventCountPerDayData.value.map(o => o.value),
            },
        ]);
    })
}

</script>